<template>
  <admin-layout>
    <template slot="content">
      <create-or-update-typology
          :mode="mode"
          :dialog="dialog"
          :typology="typology"
          @loadPage="loadPage(pageNumber)"
          @closeDialog="closeDialog()"
      ></create-or-update-typology>
      <header-for-list-component
          sectionName="Tipologias"
          :items="typologies"
          :totalItems="totalItems"
          :totalPages="totalPages"
          :itemsPerPage="itemsPerPage"
          :pageNumber.sync="pageNumber"
          @loadPage="loadPage($event)"
      />

      <v-layout
          align-center
          justify-space-between
          class="mb-3"
      >
        <v-flex xs4>
          <v-text-field
              v-model="search"
              solo
              label="Buscar Tipologia"
              prepend-inner-icon="mdi-magnify"
              hide-details
              :loading="loadingSearch"
              @input="typing()"
          >
            <template v-slot:progress>
              <v-progress-linear
                  v-if="loadingSearch"
                  color="accent"
                  indeterminate
                  height="3"
              ></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
            xs4
            class="text-xs-right">
          <v-btn
              color="primary"
              @click="selectTypology(null)">
            <v-icon>mdi-plus</v-icon>
            Adicionar Tipologia
          </v-btn>

        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
            :headers="headers"
            :items="typologies"
            hide-actions
            class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.code }}</td>
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">
              <v-icon> mdi-{{ props.item.old ? 'checkbox-marked' : 'checkbox-blank-outline' }}</v-icon>
            </td>
            <td>
              <v-layout row>

                <v-btn icon @click="showTypology(props.item.id)">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>

                <v-btn icon @click="selectTypology(props.item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>

                <delete :typology="props.item"
                        @loadPage="loadPage(pageNumber)"></delete>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </template>
  </admin-layout>
</template>

<script>
  import AdminLayout from '@/layouts/AdminLayout';
  import HeaderForListComponent from '@/components/configurations/HeaderForListComponent';
  import TypologyService from '@/services/applications/configurations/TypologyService';
  import CreateOrUpdateTypology from "./CreateOrUpdateTypology";
  import Delete from "./Delete";

  export default {
    name: 'List',
    components: {
      AdminLayout,
      CreateOrUpdateTypology,
      Delete,
      HeaderForListComponent,
    },
    mounted() {
      this.loadPage(1);
    },
    data() {
      return {
        search: '',
        typologies: [],
        typology: null,
        loadingSearch: false,
        interval: null,
        totalItems: 0,
        totalPages: 0,
        itemsPerPage: 20,
        pageNumber: 1,
        headers: [
          { text: 'ID', value: 'id', sortable: false, align: 'center' },
          { text: 'Código', value: 'code', sortable: false, align: 'center' },
          { text: 'Nome', value: 'name', sortable: false, align: 'center' },
          { text: 'Antigo', value: 'old', sortable: false, align: 'center' },
          { text: 'Ações', value: 'actions', sortable: false, align: 'center' }],
        dialog: false,
        mode: 'create',
        applicationType: null,
      };
    },
    methods: {
      showTypology(id) {
        this.$store.dispatch('setLoadingDialog', true);
        this.$router.push({ name: 'TypologyShow', params: { id } });
      },
      closeDialog() {
        this.dialog = false;
        this.applicationType = null;
      },
      loadPage(pageNumber) {
        this.pageNumber = pageNumber || this.pageNumber;
        if (!this.loadingSearch) this.$store.dispatch('setLoadingDialog', true);
        TypologyService
          .all({
            limit: this.itemsPerPage,
            page: this.pageNumber,
            q: this.search,
          })
          .then(({ data }) => {
            this.typologies = data.typologies || [];
            this.totalItems = data.total;
            this.totalPages = data.total_pages;
          })
          .finally(() => {
            this.$store.dispatch('setLoadingDialog', false);
            this.loadingSearch = false;
          });
      },
      async selectTypology(typology) {
        if (typology === null) {
          this.mode = 'create';
          this.typology = null;
        } else {
          this.typology = (await TypologyService.show(typology.id)).data;
          this.mode = 'update';
        }
        this.dialog = true;
      },
      typing() {
        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.loadingSearch = true;
          this.pageNumber = 1;
          this.loadPage();
        }, 500);
      },
    },
  };
</script>

<style scoped lang="scss">
</style>